import React from 'react'
import Femaleinferbanner from "../components/img/Femaleinferbanner.jpg";
const FemaleInfertility2Banner = () => {
  return (
<div>
    <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={Femaleinferbanner} className="d-block w-100 carousel-image" alt="..." />
        </div>
      </div>
    </div>
  </div>
  )
}

export default FemaleInfertility2Banner
